import moment from "moment";

export const snakeToTitle = (str) => {
  if (typeof str !== "string") return "";

  return str
    .split("_")
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};

export function formatCurrency(currency, value) {
  if (currency == null && value == null) {
    return new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
    }).format(0);
  }

  const finalCurrency = currency ?? "IDR";
  const finalValue = value ?? 0;

  const localeMap = {
    IDR: "id-ID",
    USD: "en-US",
  };

  const locale = localeMap[finalCurrency] || "en-US";

  const numberValue = Number(finalValue);
  if (Number.isNaN(numberValue)) {
    throw new Error("value is not a number");
  }

  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: finalCurrency,
  }).format(numberValue);
}

export const formatDate = (date) => {
  if (!date) return "";
  return date ? moment(date).format("D MMMM YYYY") : "-";
};

export const formatLongDate = (date) => {
  const tanggalObj = new Date(date);

  const options = {
    day: "numeric",
    month: "long",
    year: "numeric",
  };

  return new Intl.DateTimeFormat("en-US", options).format(tanggalObj);
};

export const formatDateForInput = (date) => {
  if (!date) return "";
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export function formatTime(timeString) {
  const jam = timeString.substring(0, 2);

  const menit = timeString.substring(3, 5);

  return `${jam}.${menit}`;
}

export const modifyStatus = (status) => {
  switch (status) {
    case "rejected":
      return "Rejected";
    case "submitted":
      return "Enrolled";
    case "approved":
      return "Approved";
    case "canceled":
      return "Canceled";
    default:
      return "";
  }
};

export const getTrainingTypeIcon = (type) => {
  switch (type) {
    case "OL":
      return "fe fe-smartphone";
    case "IH":
      return "fe fe-home";
    default:
      return "fe fe-book";
  }
};

export const getTrainingStatusClass = (status) => {
  switch (status) {
    case "open":
      return "badge badge-info";
    case "approval_manager":
      return "badge badge-warning";
    case "approval_hr":
      return "badge badge-warning";
    case "enrollment_pending":
      return "badge badge-primary";
    case "enrolled":
      return " badge badge-success";
    case "in_review":
      return "badge badge-warning";
    case "rejected":
      return "badge badge-danger";
    case "completed":
      return "badge badge-success";
    case "submitted":
      return "badge badge-warning";
    case "approved":
      return "badge badge-success";
    case "scheduled":
      return "badge badge-warning";
    case "to do":
      return "badge badge-warning";
    case "in progress":
      return "badge badge-info";
    case "in_progress":
      return "badge badge-info";
    case "in review":
      return "badge badge-info";
    default:
      return "badge";
  }
};

export function cleanObject(obj) {
  return Object.fromEntries(
    Object.entries(obj).filter(([, v]) => v !== null && v !== undefined && v !== "" && !(Array.isArray(v) && v.length === 0))
  );
}

export function formatTimeToHHMM(timeString) {
  if (!timeString) return "-";

  const regex = /^(\d{2}):(\d{2})(?::\d{2}(?:\.\d+)?)?(?:([+-]\d{2})(?::?\d{2})?)?$/;
  const match = timeString.match(regex);

  if (!match) {
    throw new Error("Invalid time format. Expected HH:MM or HH:MM:SS (optional offset)");
  }

  const [, hh, mm, offset] = match;

  let zone = "WIB";
  if (offset) {
    switch (offset) {
      case "+07":
        zone = "WIB";
        break;
      case "+08":
        zone = "WITA";
        break;
      case "+09":
        zone = "WIT";
        break;
      default:
        zone = `UTC${offset}`;
    }
  }

  return `${hh}:${mm} ${zone}`;
}

export function isPdfFile(url) {
  if (typeof url !== "string") return false;

  const cleanUrl = url.split("?")[0].toLowerCase();

  return cleanUrl.endsWith(".pdf");
}
